import { LogLevel } from "@azure/msal-browser";

const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_SIGNUP_USER_JOURNEY,
        forgotPassword: process.env.REACT_APP_FORGOTPASSWORD_USER_JOURNEY,
        signIn: process.env.REACT_APP_SIGNIN_USER_JOURNEY
    },
    authorities: {
        signUpSignIn: {
            authority: `https://halleyb2c.b2clogin.com/halleyb2c.onmicrosoft.com/${process.env.REACT_APP_SIGNUP_USER_JOURNEY}`,
        },
        forgotPassword: {
            authority: `https://halleyb2c.b2clogin.com/halleyb2c.onmicrosoft.com/${process.env.REACT_APP_FORGOTPASSWORD_USER_JOURNEY}`,
        },
        signIn: {
            authority: `https://halleyb2c.b2clogin.com/halleyb2c.onmicrosoft.com/${process.env.REACT_APP_SIGNIN_USER_JOURNEY}`
        }
    },
    authorityDomain: "halleyb2c.b2clogin.com"
}

const signInConfig = {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: b2cPolicies.authorities.signIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    navigateToLoginRequestUrl: true
}

const signUpConfig = {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    navigateToLoginRequestUrl: true
}

const cache = {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
}

const system = {
    loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
                return;
            }

            switch (level) {
                case LogLevel.Error:
                    console.error(message);
                    return;
                case LogLevel.Verbose:
                    console.debug(message);
                    return;
                case LogLevel.Warning:
                    console.warn(message);
                    return;
                default:
                    console.info(message);
                    break;
            }
        }
    }
}

export const msalConfig = {
    auth: signInConfig,
    cache: cache,
    system: system
};

export const msalSigUpConfig = {
    auth: signUpConfig,
    cache: cache,
    system: system
};

export const loginRequest = {
    scopes: ["openid", "profile", "email", "offline_access", process.env.REACT_APP_CLIENT_ID]
};
